import { render, staticRenderFns } from "./IndustriesPills.vue?vue&type=template&id=f56e5e3e&scoped=true&"
import script from "./IndustriesPills.vue?vue&type=script&lang=js&"
export * from "./IndustriesPills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56e5e3e",
  null
  
)

export default component.exports